import React, { useEffect } from "react";
import * as echarts from "echarts";

const MoodLineChart = ({ chartData }: any) => {
  const isInsights = window.location.pathname.startsWith("/insights");

  useEffect(() => {
    const data = chartData.Avg || [];
    const color = chartData.color || "#DDD";
    console.log(data, "MoodLineChart");

    const chart = echarts.init(
      document.getElementById("mood-line-chart") as HTMLDivElement
    );

    const seriesData = data?.map((item: any) => item?.avg);

    function hexToRGBA(hex: string, alpha: number) {
      let r = 0, g = 0, b = 0;
      if (hex.startsWith("#")) {
        if (hex.length === 7) {
          r = parseInt(hex.slice(1, 3), 16);
          g = parseInt(hex.slice(3, 5), 16);
          b = parseInt(hex.slice(5, 7), 16);
        } else if (hex.length === 4) {
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        }
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    const options = {
      grid: {
        top: 40,
  right: 20,
  bottom: 20,
  left: 20,
        containLabel: true,
        
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: data?.map((item: any) => item.day),
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 11 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 3,
        interval: 1,
        axisLine: { show: false },
        axisTick: { show: false },
       axisLabel: {
  margin: 12,
  formatter: (val: number) => {
    const map: Record<number, string> = {
      0: "{happy|}",
      1: "{sad|}",
      2: "{angry|}",
      3: "{neutral|}",
    };
    return map[val] || "";
  },
  rich: {
    happy: {
      height: 20,
      width: 20,
      align: "center",
      backgroundColor: {
        image: "/img/angry_new.svg",
      },
    },
    sad: {
      height: 20,
      width: 20,
      align: "center",
      backgroundColor: {
        image: "/img/sad_new.svg",
      },
    },
    angry: {
      height: 20,
      width: 20,
      align: "center",
      backgroundColor: {
        image: "/img/neutral_new.svg",
      },
    },
    neutral: {
      height: 20,
      width: 20,
      align: "center",
      backgroundColor: {
        image: "/img/happy_new.svg",
      },
    },
  },
},
        splitLine: { lineStyle: { color: "#e6e9f7" } },
      },
      series: [
        {
          data: seriesData,
          type: "line",
           clip: false, 
          smooth: true,
          showSymbol: false,
          symbol: "none",
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: hexToRGBA(color, 0.5) },
              { offset: 1, color: hexToRGBA(color, 0) },
            ]),
          },
          lineStyle: {
            color: "#b21e49",
            width: 2,
          },
        },
      ],
    };

    chart.setOption(options);

    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="mood-line-chart"
      style={{
        width: "100%",
        height: isInsights ? "257px" : "400px",
      }}
    />
  );
};

export default MoodLineChart;